import { fork, take, put, call } from 'redux-saga/effects';
import { logoutSucces } from '../App/actions';
import { changeEmail, changePassword, sendFeedback } from './actions';
import apiService from '../../api/apiServices/apiService';
import { history } from '../../main';
import { toast } from 'react-toastify';

function* watchChangePassword() {
  while (true) {
    const { payload }: ReturnType<typeof changePassword> = yield take(changePassword.type);
    const { oldPassword, newPassword } = payload;

    const { success, reject } = yield call(
      [apiService, apiService.changePassword],
      oldPassword,
      newPassword,
    );
    if (success) {
      toast.success('Password has been changed. Sign in now.');
      yield put(logoutSucces());
      history.push('/');
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchChangeEmail() {
  while (true) {
    const { payload }: ReturnType<typeof changeEmail> = yield take(changeEmail.type);
    const { newEmail } = payload;

    const { success, reject } = yield call([apiService, apiService.changeEmail], newEmail);
    if (success) {
      toast.success('Email has been changed. Sign in now.');
      yield put(logoutSucces());
      history.push('/');
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchSendFeedback() {
  while (true) {
    const { payload }: ReturnType<typeof sendFeedback> = yield take(sendFeedback.type);
    const { subject, message } = payload;

    const { success, reject } = yield call([apiService, apiService.sendFeedback], subject, message);
    if (success) {
      toast.success('Your message has been sent to support');
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* userProfileSaga() {
  yield fork(watchChangePassword);
  yield fork(watchChangeEmail);
  yield fork(watchSendFeedback);
}
